export const formatMinutesToHHMMSS = (minutes) => {
	if (typeof minutes !== 'number' || minutes < 0 || isNaN(minutes))
		return '00:00:00'

	const totalSeconds = Math.round(minutes * 60)
	const hours = Math.floor(totalSeconds / 3600)
	const mins = Math.floor((totalSeconds % 3600) / 60)
	const secs = totalSeconds % 60

	return [hours, mins, secs].map((v) => String(v).padStart(2, '0')).join(':')
}

export const formatDate = (dateString) => {
	const date = new Date(dateString)
	return date
		.toLocaleString('pt-BR', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
		})
		.replace(',', ' –')
}

export function formatDateKey(value) {
	if (!value) return ''
	const date = new Date(value)
	return date.toLocaleDateString('pt-BR', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	})
}

export function formatFileSize(fileSize) {
	if (!fileSize) return ''

	const fileSizeMB = fileSize / (1024 * 1024)

	if (fileSizeMB >= 1) return `${fileSizeMB.toFixed(2)} MB`

	return `${(fileSize / 1024).toFixed(2)} KB`
}
